module.exports = __webpack_public_path__ + "static/media/point figure.b775d194.svg";